import React from 'react';
import { upperFirst } from 'lodash';
import { EmojiPrefix } from '../../view';

export const Option = (props: any) => {
    const { children, className, cx, isDisabled, isFocused, isSelected, innerRef, innerProps, data } = props;
    const cy = `selector${upperFirst(data?.value)}`;

    return (
        <div
            className={cx(
                {
                    option: true,
                    'option--is-disabled': isDisabled,
                    'option--is-focused': isFocused,
                    'option--is-selected': isSelected,
                },
                className,
            )}
            ref={innerRef}
            data-cy={cy}
            {...innerProps}
        >
            {data.emojiString && <EmojiPrefix>{data.emojiString}</EmojiPrefix>}
            {children}
        </div>
    );
};
